import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { ItemResponse, PortalAssemblyResponse } from '@proerp/shared';
import { portalRequest } from './apiClient';

export const PORTAL_ASSEMBLY_KEY = ['portal', 'assembly'] as const;

/**
 * Die diesem Partner zugeordneten Montage-Einsätze (ADR 0085, Stufe 2).
 * `enabled`: siehe `usePortalForecast` — die Übersicht fragt nur, was für
 * diesen Zugang freigeschaltet ist.
 */
export function usePortalAssembly(
  options: { enabled?: boolean } = {},
): UseQueryResult<PortalAssemblyResponse> {
  return useQuery({
    queryKey: PORTAL_ASSEMBLY_KEY,
    queryFn: async () => {
      const response = await portalRequest<ItemResponse<PortalAssemblyResponse>>('/assembly');
      return response.data;
    },
    enabled: options.enabled ?? true,
    retry: false,
  });
}
